import React from 'react';
import { Button } from '@/components/ui/button';
import { User } from 'lucide-react';

export default function HeroSection({ onLoginClick }) {
  return (
    <div className="sz-hero relative h-80 sm:h-96 overflow-hidden">
      <div className="absolute inset-0 bg-gradient-to-b from-black/40 via-transparent to-black/30"></div>
      <div className="relative h-full max-w-7xl mx-auto px-4 sm:px-6 flex flex-col justify-center items-center text-center">
        <div className="mb-4 sm:mb-6">
          <img
            src="/images/smashzone-logo.jpeg"
            alt="SmashZone"
            className="h-20 w-20 sm:h-28 sm:w-28 lg:h-32 lg:w-32 mx-auto rounded-full shadow-2xl border-4 border-white object-cover"
            loading="eager"
          />
        </div>
        <h1 className="text-4xl sm:text-5xl lg:text-6xl font-black font-heading uppercase text-white mb-2 tracking-tight drop-shadow-lg">
          SmashZone
        </h1>
        <p className="text-lg sm:text-xl lg:text-2xl text-emerald-100 font-semibold mb-3 drop-shadow-md">
          Brunei's easiest way to play badminton and pickleball.
        </p>
        <p className="text-base sm:text-lg text-white/90 mb-6 max-w-2xl">
          Book in seconds. Pay online. Show up and play.
        </p>
        <div className="flex gap-3 sm:gap-4">
          <Button
            onClick={onLoginClick}
            data-testid="login-button"
            className="bg-white text-emerald-700 hover:bg-emerald-50 h-12 sm:h-14 px-6 sm:px-8 text-base sm:text-lg font-bold shadow-xl"
          >
            <User className="w-5 h-5 mr-2" />
            Login / Sign Up
          </Button>
        </div>
      </div>
    </div>
  );
}
